module.exports = __webpack_public_path__ + "lowChances.png";